import React, { useEffect, useState } from 'react'
import Agreement from '../../components/FormTools/Agreement'
import { WhiteSpace } from 'antd-mobile'
import { FormattedMessage } from 'react-intl'

export default function OwsiAgreement({ changeChecked }) {
  const [agreementOne, setAgreementOne] = useState(false)
  const [agreementTwo, setAgreementTwo] = useState(false)

  useEffect(() => {
    changeChecked(agreementOne && agreementTwo)
  }, [agreementOne, agreementTwo])

  return (
    <>
      <Agreement setChecked={(val) => setAgreementOne(val)} checked={agreementOne}>
        <FormattedMessage id="owsi-cd-agreement-one" />
      </Agreement>
      <WhiteSpace />
      <Agreement setChecked={(val) => setAgreementTwo(val)} checked={agreementTwo}>
        <FormattedMessage id="owsi-cd-agreement-two" />
      </Agreement>
    </>
  )
}
